module.exports = __webpack_public_path__ + "img/kj2.936d4eeb.png";